<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-09-16 18:26:01
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-08 10:48:58
-->
<template>
  <div id="admin-clock">
    <van-tabs
      v-model="active"
      color="#0070FF"
      title-active-color="#0070FF"
      @click="beforeChange"
    >
      <van-tab title="商品">
        <center></center>
      </van-tab>
      <van-tab title="机构">
        <mechanism v-on="$listeners"></mechanism>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import center from './center'
import mechanism from './mechanism'
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  components: {
    center,
    mechanism
  },
  data() {
    return {
      active: 0
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    beforeChange(val) {
      this.buriedPoint()
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    }
  }
}
</script>
<style lang="scss" scoped>
#admin-clock {
  ::v-deep .van-tabs {
    .van-tabs__wrap {
      box-shadow: 0 1px 10px 1px rgba(0, 0, 0, 0.05);
      position: relative;
      z-index: 99;
    }
  }
}
</style>
